import {
  addDays,
  addMonths,
  addWeeks,
  endOfDay,
  endOfMonth,
  endOfWeek,
  format,
  startOfDay,
  startOfMonth,
  startOfWeek,
} from "date-fns";

export type CalendarPeriod = "timeGridDay" | "timeGridWeek" | "dayGridMonth";

export const getPeriodBounds = (view: CalendarPeriod, date: Date) => {
  switch (view) {
    case "timeGridDay":
      return { start: startOfDay(date), end: endOfDay(date) };
    case "timeGridWeek":
      return {
        start: startOfWeek(date, { weekStartsOn: 1 }),
        end: endOfWeek(date, { weekStartsOn: 1 }),
      };
    case "dayGridMonth":
    default:
      return { start: startOfMonth(date), end: endOfMonth(date) };
  }
};

export const shiftAnchorDate = (
  view: CalendarPeriod,
  date: Date,
  direction: -1 | 1
) => {
  switch (view) {
    case "timeGridDay":
      return addDays(date, direction);
    case "timeGridWeek":
      return addWeeks(date, direction);
    case "dayGridMonth":
    default:
      return addMonths(date, direction);
  }
};

export const formatPeriodTitle = (view: CalendarPeriod, date: Date) => {
  const { start, end } = getPeriodBounds(view, date);
  switch (view) {
    case "timeGridDay":
      return format(start, "MMMM d, yyyy");
    case "timeGridWeek":
      return `${format(start, "MMM d")} – ${format(end, "MMM d, yyyy")}`;
    case "dayGridMonth":
    default:
      return format(start, "MMMM yyyy");
  }
};

export const formatRangeForApi = (start: Date, end: Date) => ({
  start: format(start, "yyyy-MM-dd'T'00:00:00"),
  end: format(end, "yyyy-MM-dd'T'23:59:59"),
});
